import { Kmehrelement } from './kmehrelement';

export class Kmehrcd extends Kmehrelement{
    public s;
    public sl;
    public dn;
    public l;

    fromJson(json: any) {
        if (!json) {
            return;
        }
        const jsonKeys = Object.keys(json);
        if (jsonKeys && Array.isArray(jsonKeys)) {
            jsonKeys.forEach(key => {
                switch (key) {
                    case 's':
                        {
                            this.s = json[key];
                        }
                        break;
                    case 'dn':
                        {
                            this.dn = json[key];
                        }
                        break;
                    case 'sl':
                        {
                            this.sl = json[key];
                        }
                        break;
                    case 'l':
                        {
                            this.l = json[key];
                        }
                        break;
                    case 'value':
                        {
                            this.value = json[key];
                        }
                        break;
                }
            });
        }
    }
}
